// extracted by mini-css-extract-plugin
module.exports = {"login-layout":"login-layout_login-layout__4Pxi_","header":"login-layout_header__qgkA2","footer":"login-layout_footer__PMchR","separate":"login-layout_separate__HDUZT"};